import React, { useState, useEffect } from 'react';
import nawatechLogo from "../assets/nawatech-logo.png"
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import "./LoginPage.css"
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { login } from '../libs/redux/slices/authSlice';
import useDocumentTitle from '../hooks/useDocumentTitle';
import LoadingPage from '../LoadingPage';
import axiosAuth from '../libs/axios/axiosAuth';

const SSO_INACTIVE_USER = "INACTIVE_USER"
const SSO_NOT_REGISTERED = "NOT_REGISTERED"
const SSO_LOGIN_FAILED = "LOGIN_FAILED"
const SSO_NOT_AUTHENTICATED = "NOT_AUTHENTICATED"
const SSO_LOGOUT_SUCCESS = "LOGOUT_SUCCESS"

const LoginError = ({ title, message }) => {
  return <div className="login-error login-container">
    <div className='card'>
      <img src={nawatechLogo} alt="Img" className="logo" />
      <h1>{title}</h1>
      <div className="message">
        {message}
      </div>
      <Link to='/login' className='btn-primary'>Back to Login</Link>
    </div>
  </div>
}

const LoginPage = () => {
  useDocumentTitle('Login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessasge] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [queryParams] = useSearchParams();

  if (queryParams.get("msg")) {
    let encodedMsg = queryParams.get("msg")
    // const paddingNeeded = 4 - (encodedMsg.length % 4)
    // if (paddingNeeded) {
    //   encodedMsg += "=".repeat(paddingNeeded)
    // }
    const decodedMsg = atob(encodedMsg)
    if (decodedMsg === SSO_NOT_REGISTERED) {
      return <LoginError title={"Account Not Registered"} message="Unfortunately! It seems that your account has not been registered yet by the administrator. If you need assistance with registering your account, please contact our support team" />
    } else if (decodedMsg === SSO_LOGIN_FAILED) {
      return <LoginError title={"Login Failed"} message="Oops! Something went wrong on our end. We're experiencing a temporary server issue, preventing login at the moment. Please try again later or contact our support team for assistance." />
    } else if (decodedMsg === SSO_NOT_AUTHENTICATED) {
      return <LoginError title={"Login Failed"} message="Oops! Something went wrong on our end. We're experiencing a temporary server issue, preventing login at the moment. Please try again later or contact our support team for assistance." />
    } else if (decodedMsg === SSO_INACTIVE_USER) {
      return <LoginError title={"Account Inactive"} message="Unfortunately! It seems that your account status has been set to inactive by the administrator. If you need assistance with re-activating your account, please contact our support team" />
    } else if (decodedMsg === SSO_LOGOUT_SUCCESS) {
      return <LoginError title={"Logout Success"} message="You have successfully logged out. Please login again to continue." />
    }
  }

  const handleClaim = async (claim) => {
    // const URL = "http://localhost:8000/auth/claim";
    // const URL = "https://genai-api.nawatech.co/auth/claim";
    const URL = "https://evadev-api.sinarmas-agri.com/auth/claim";
    try {
      const response = await axios.post(URL, { claim_token: claim })
      if (response.status === 200) {
        const result = response.data;
        localStorage.setItem('access_token', result.data.access_token);
        const ORIGIN = window.location.origin;
        window.location.href = `${ORIGIN}/home`;
      }
    } catch (error) {
      console.error('failed to claim', error)
      const encodeMsg = btoa(SSO_LOGIN_FAILED)
      navigate(`/login?msg=${encodeMsg}`)
    }
  }

  if (queryParams.get('claim')) {
    const claim = queryParams.get('claim');
    handleClaim(claim);
    return <LoadingPage />;
  }

  // uncomment once sso is ready

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const queryToken = urlParams.get('token'); 
  //   const queryNik = urlParams.get('nik'); 

  //   if (queryToken && queryNik) {
  //     sessionStorage.setItem('nik', queryNik);
  //     navigate('/home');
  //   }
  // }, [navigate]);

  // const handleLogin = () => {
  //   //change to sinarmas sso url
  //   const ssoUrl = `http://localhost:3001?nik=${nik}`;

  //   window.location.href = ssoUrl;
  // };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const url = `api/users/login`;
    try {
      const response = await axiosAuth.post(url, {
        nik: username,
        password: password,
      }, {
        headers: {
          'X-API-Key': 'b05d7955a5014d3c081f1e9ef6864782c7fda725ac99725a89d286e0835796b4b624285d0cc4cec6',
        },
      });
      if (response.status === 200) {
        const result = response.data;
        localStorage.setItem('access_token', result.data.access_token);
        dispatch(login());
        navigate('/home');
        setIsLoading(false);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setErrorMessasge('Invalid nik or password');
      } else {
        setErrorMessasge('Login Failed')
      }
      setIsLoading(false);
    }
  };

  const handleLoginWithSSO = () => {
    const ORIGIN = window.location.origin;
    window.location.href = `https://evadev-api.sinarmas-agri.com/auth/login?relay_state=${ORIGIN}/login`;
  }

  return (
    <div className="login-container">
      <img src={nawatechLogo} alt="Nawatech Logo" className="logo" />
      {errorMessage && <p style={{ margin: 0, paddingBottom: "8px", color: "red", textAlign: "left" }}>{errorMessage}</p>}
      <form onSubmit={handleLogin}>
        <div className="login-form">
          <input
            type="text"
            placeholder="Enter NIK"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type='submit' disabled={isLoading}>Login</button>
        </div>
      </form>
      {/* <button onClick={handleLoginWithSSO} className='btn-style-reset' disabled={isLoading}>Login With SSO</button> */}
    </div>
  );
};

export default LoginPage;